import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=01f5e778&"
import script from "./Edit.vue?vue&type=script&lang=ts&"
export * from "./Edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f5e778')) {
      api.createRecord('01f5e778', component.options)
    } else {
      api.reload('01f5e778', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=01f5e778&", function () {
      api.rerender('01f5e778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Edit.vue"
export default component.exports